var anObject = require('../internals/an-object');
var iteratorClose = require('../internals/iterator-close');

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/call-with-safe-iteration-closing.js
// module id = 1242
// module chunks = 1